// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderReview_container__qKcY\\+ {
  padding: 2rem;
  animation: OrderReview_init__SPi62 0.5s;
}

.OrderReview_header__gk1v3 {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}

.OrderReview_header__gk1v3 h1 {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 300;
}

.OrderReview_infoCard__XhE13,
.OrderReview_summaryCard__klrnl,
.OrderReview_detailsCard__05ZL7 {
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.OrderReview_infoItem__CUgQ\\+ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.OrderReview_infoItem__CUgQ\\+:last-child {
  border-bottom: none;
}

.OrderReview_actionsContainer__ynOEa {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
  padding: 2rem 0;
}

.OrderReview_loader__OeLUK {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 4rem;
  min-height: 400px;
}

@keyframes OrderReview_init__SPi62 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Pages/AgencyOrders/Backoffice/OrderReview/OrderReview.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uCAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  padding: 2rem;\n  animation: init 0.5s;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.header h1 {\n  margin: 0;\n  font-size: 1.8rem;\n  font-weight: 300;\n}\n\n.infoCard,\n.summaryCard,\n.detailsCard {\n  margin-bottom: 2rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.infoItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.infoItem:last-child {\n  border-bottom: none;\n}\n\n.actionsContainer {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 2rem;\n  padding: 2rem 0;\n}\n\n.loader {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 4rem;\n  min-height: 400px;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OrderReview_container__qKcY+`,
	"init": `OrderReview_init__SPi62`,
	"header": `OrderReview_header__gk1v3`,
	"infoCard": `OrderReview_infoCard__XhE13`,
	"summaryCard": `OrderReview_summaryCard__klrnl`,
	"detailsCard": `OrderReview_detailsCard__05ZL7`,
	"infoItem": `OrderReview_infoItem__CUgQ+`,
	"actionsContainer": `OrderReview_actionsContainer__ynOEa`,
	"loader": `OrderReview_loader__OeLUK`
};
export default ___CSS_LOADER_EXPORT___;
